import type { EventData } from "@/lib/events/types"
import {
  formatNotificationEventDateLabel,
  getEventPrefillDateYmd,
  getEventPrefillTimePickerLabel,
} from "@/lib/events/event-datetime"

type EventShareFields = Pick<
  EventData,
  "title" | "date" | "startDateLocal" | "time" | "startTimeLocal"
>

/**
 * Web Share API payload: short invitation line + URL (platforms merge `text` + `url`).
 * Default matches `{Title} · {Date} at {Time}`; optional long form adds “Join us”.
 */
export function buildEventWebSharePayload(input: {
  event: EventShareFields
  absoluteUrl: string
  longForm?: boolean
}): { title: string; text: string; url: string } {
  const title = input.event.title?.trim() || "Event"
  const ymd = getEventPrefillDateYmd(input.event)
  const datePart = ymd ? formatNotificationEventDateLabel(ymd) : ""
  const timePart =
    getEventPrefillTimePickerLabel(input.event) ??
    input.event.time?.trim() ??
    ""

  const url = input.absoluteUrl.trim()

  let text: string
  if (input.longForm) {
    if (datePart && timePart) {
      text = `${title} — ${datePart}, ${timePart}\nJoin us:`
    } else if (datePart) {
      text = `${title} — ${datePart}\nJoin us:`
    } else {
      text = `${title}\nJoin us:`
    }
  } else if (datePart && timePart) {
    text = `${title} · ${datePart} at ${timePart}`
  } else if (datePart) {
    text = `${title} · ${datePart}`
  } else {
    text = title
  }

  return { title, text, url }
}
